import ResolutionController from '../Controllers/ResolutionController'

class Config {
    readonly AUDIO_FILE_EXT = '.mp3'
    readonly VIDEO_FILE_EXT = '.mp4'

    readonly ASSET_PATH = 'assets/'
    readonly CINEMATIC_PATH = this.ASSET_PATH + 'video/'
    readonly LEVEL_PATH = this.ASSET_PATH + 'levels/'
    readonly GAME_SCENE_PATH = this.ASSET_PATH + 'kulissen/'
    readonly DIALOG_PATH = this.ASSET_PATH + 'dialogs/'
    readonly INVENTORY_IMAGE_PATH = this.ASSET_PATH + 'graphics/inventory/'
    readonly AUDIO_PATH = this.ASSET_PATH + 'audio/'
    readonly INVENTORY_AUDIO_PATH = this.ASSET_PATH + 'audio/Inventarbezeichnungen/'
    readonly INVENTORY_COMBINATION_AUDIO_PATH = this.ASSET_PATH + 'audio/Inventar_Kombinieren/'
    readonly RANDOM_YES_AUDIO_PATH = this.ASSET_PATH + 'audio/random_yes/'
    readonly RANDOM_NO_AUDIO_PATH = this.ASSET_PATH + 'audio/random_no/'
    readonly MISSING_IMAGE_PATH = this.ASSET_PATH + 'graphics/missing_image.png'

    readonly RANDOM_YES_MANIFEST_URL = this.RANDOM_YES_AUDIO_PATH + 'manifest.json'
    readonly RANDOM_NO_MANIFEST_URL = this.RANDOM_NO_AUDIO_PATH + 'manifest.json'

    readonly resolution = ResolutionController

    isMuted = false
}

export default new Config()
